import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-7db585ca.js';
import { inject } from '@ember/service';
import Helper from '@ember/component/helper';
import handleQueryParams from '../utils/handle-query-params.js';

var _class, _descriptor;
let TransitionToHelper = (_class = class TransitionToHelper extends Helper {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "router", _descriptor, this);
  }

  compute(_params) {
    return maybeEvent => {
      if (maybeEvent !== undefined && typeof maybeEvent.preventDefault === 'function') {
        maybeEvent.preventDefault();
      }

      let params = handleQueryParams(_params);
      return this.router.transitionTo(...params);
    };
  }

}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);

export { TransitionToHelper as default };
